const carModels = [
  { id: 1, name: "ILX", value: "ilx", make: "acura" },
  { id: 2, name: "MDX", value: "mdx", make: "acura" },
  { id: 3, name: "NSX", value: "nsx", make: "acura" },
  { id: 4, name: "RDX", value: "rdx", make: "acura" },
  { id: 5, name: "TLX", value: "tlx", make: "acura" },

  { id: 6, name: "A3", value: "a3", make: "audi" },
  { id: 7, name: "A4", value: "a4", make: "audi" },
  { id: 8, name: "A5", value: "a5", make: "audi" },
  { id: 9, name: "A6", value: "a6", make: "audi" },
  { id: 10, name: "Q3", value: "q3", make: "audi" },
  { id: 11, name: "Q5", value: "q5", make: "audi" },
  { id: 12, name: "Q7", value: "q7", make: "audi" },

  { id: 13, name: "Continental GT", value: "continental-gt", make: "bentley" },
  { id: 14, name: "Flying Spur", value: "flying-spur", make: "bentley" },
  { id: 15, name: "Bentayga", value: "bentayga", make: "bentley" },

  { id: 16, name: "X1", value: "x1", make: "bmw" },
  { id: 17, name: "X3", value: "x3", make: "bmw" },
  { id: 18, name: "X5", value: "x5", make: "bmw" },
  { id: 19, name: "3 Series", value: "3-series", make: "bmw" },
  { id: 20, name: "5 Series", value: "5-series", make: "bmw" },

  { id: 21, name: "Enclave", value: "enclave", make: "buick" },
  { id: 22, name: "Encore", value: "encore", make: "buick" },
  { id: 23, name: "Envision", value: "envision", make: "buick" },

  { id: 24, name: "Escalade", value: "escalade", make: "cadillac" },
  { id: 25, name: "XT4", value: "xt4", make: "cadillac" },
  { id: 26, name: "XT5", value: "xt5", make: "cadillac" },
  { id: 27, name: "XT6", value: "xt6", make: "cadillac" },

  { id: 28, name: "Camaro", value: "camaro", make: "chevrolet" },
  { id: 29, name: "Corvette", value: "corvette", make: "chevrolet" },
  { id: 30, name: "Malibu", value: "malibu", make: "chevrolet" },
  { id: 31, name: "Silverado", value: "silverado", make: "chevrolet" },
  { id: 32, name: "Tahoe", value: "tahoe", make: "chevrolet" },

  { id: 33, name: "300", value: "300", make: "chrysler" },
  { id: 34, name: "Pacifica", value: "pacifica", make: "chrysler" },

  { id: 35, name: "Charger", value: "charger", make: "dodge" },
  { id: 36, name: "Challenger", value: "challenger", make: "dodge" },
  { id: 37, name: "Durango", value: "durango", make: "dodge" },

  { id: 38, name: "500", value: "500", make: "fiat" },
  { id: 39, name: "500X", value: "500x", make: "fiat" },

  { id: 40, name: "F-150", value: "f-150", make: "ford" },
  { id: 41, name: "Mustang", value: "mustang", make: "ford" },
  { id: 42, name: "Escape", value: "escape", make: "ford" },
  { id: 43, name: "Explorer", value: "explorer", make: "ford" },

  { id: 44, name: "Sierra", value: "sierra", make: "gmc" },
  { id: 45, name: "Yukon", value: "yukon", make: "gmc" },

  { id: 46, name: "Civic", value: "civic", make: "honda" },
  { id: 47, name: "Accord", value: "accord", make: "honda" },
  { id: 48, name: "CR-V", value: "cr-v", make: "honda" },

  { id: 49, name: "Elantra", value: "elantra", make: "hyundai" },
  { id: 50, name: "Santa Fe", value: "santa-fe", make: "hyundai" },

  { id: 51, name: "Q50", value: "q50", make: "infiniti" },
  { id: 52, name: "QX60", value: "qx60", make: "infiniti" },

  { id: 53, name: "F-Pace", value: "f-pace", make: "jaguar" },
  { id: 54, name: "XE", value: "xe", make: "jaguar" },

  { id: 55, name: "Wrangler", value: "wrangler", make: "jeep" },
  { id: 56, name: "Cherokee", value: "cherokee", make: "jeep" },

  { id: 57, name: "Soul", value: "soul", make: "kia" },
  { id: 58, name: "Sportage", value: "sportage", make: "kia" },

  { id: 59, name: "Huracan", value: "huracan", make: "lamborghini" },
  { id: 60, name: "Urus", value: "urus", make: "lamborghini" },

  { id: 61, name: "RX", value: "rx", make: "lexus" },
  { id: 62, name: "IS", value: "is", make: "lexus" },

  { id: 63, name: "Navigator", value: "navigator", make: "lincoln" },

  { id: 64, name: "Ghibli", value: "ghibli", make: "maserati" },
  { id: 65, name: "Levante", value: "levante", make: "maserati" },

  { id: 66, name: "CX-5", value: "cx-5", make: "mazda" },
  { id: 67, name: "Mazda3", value: "mazda3", make: "mazda" },

  { id: 68, name: "C-Class", value: "c-class", make: "mercedes-benz" },
  { id: 69, name: "GLC", value: "glc", make: "mercedes-benz" },
  // Mini
  { id: 70, name: "Cooper", value: "cooper", make: "mini" },
  { id: 71, name: "Countryman", value: "countryman", make: "mini" },
  { id: 72, name: "Clubman", value: "clubman", make: "mini" },

  // Mitsubishi
  { id: 73, name: "Lancer", value: "lancer", make: "mitsubishi" },
  { id: 74, name: "Outlander", value: "outlander", make: "mitsubishi" },
  { id: 75, name: "Pajero", value: "pajero", make: "mitsubishi" },

  // Nissan
  { id: 76, name: "Sentra", value: "sentra", make: "nissan" },
  { id: 77, name: "Altima", value: "altima", make: "nissan" },
  { id: 78, name: "Frontier", value: "frontier", make: "nissan" },
  { id: 79, name: "GT-R", value: "gt-r", make: "nissan" },

  // Porsche
  { id: 80, name: "911", value: "911", make: "porsche" },
  { id: 81, name: "Cayenne", value: "cayenne", make: "porsche" },
  { id: 82, name: "Macan", value: "macan", make: "porsche" },
  { id: 83, name: "Taycan", value: "taycan", make: "porsche" },

  // Rolls-Royce
  { id: 84, name: "Phantom", value: "phantom", make: "rolls-royce" },
  { id: 85, name: "Ghost", value: "ghost", make: "rolls-royce" },
  { id: 86, name: "Wraith", value: "wraith", make: "rolls-royce" },

  // Scion
  { id: 87, name: "FR-S", value: "fr-s", make: "scion" },
  { id: 88, name: "iM", value: "im", make: "scion" },
  { id: 89, name: "tC", value: "tc", make: "scion" },

  // Smart
  { id: 90, name: "Fortwo", value: "fortwo", make: "smart" },
  { id: 91, name: "Forfour", value: "forfour", make: "smart" },

  // Subaru
  { id: 92, name: "Impreza", value: "impreza", make: "subaru" },
  { id: 93, name: "Outback", value: "outback", make: "subaru" },
  { id: 94, name: "Forester", value: "forester", make: "subaru" },

  // Toyota
  { id: 95, name: "Corolla", value: "corolla", make: "toyota" },
  { id: 96, name: "Camry", value: "camry", make: "toyota" },
  { id: 97, name: "RAV4", value: "rav4", make: "toyota" },
  { id: 98, name: "Hilux", value: "hilux", make: "toyota" },

  // Volkswagen
  { id: 99, name: "Golf", value: "golf", make: "volkswagen" },
  { id: 100, name: "Jetta", value: "jetta", make: "volkswagen" },
  { id: 101, name: "Tiguan", value: "tiguan", make: "volkswagen" },
  { id: 102, name: "Passat", value: "passat", make: "volkswagen" },

  // Volvo
  { id: 103, name: "XC60", value: "xc60", make: "volvo" },
  { id: 104, name: "XC90", value: "xc90", make: "volvo" },
  { id: 105, name: "S60", value: "s60", make: "volvo" },
];

export default [...carModels];
